if(collectioTitle === "Products") {
  collectioTitle = "*:*";
  console.log('1'+collectioTitle);
} else {
  if(collectioTitle.indexOf("-")) {
    collectioTitle = collectioTitle.replace(/-/g, '/');
    console.log('2'+collectioTitle);
  }
  if(collectioTitle.includes('Outlet')){
    collectioTitle = 'plpProductCallout:"ONLINE OUTLET"';
  }
  else{
    if(collectioQuery) {
      console.log('3'+collectioQuery);
      const collectionQueryArray = collectioQuery.split("|");
      const catQueryArray = collectionQueryArray[0].split(":");
      collectioTitle = catQueryArray[0].trim() + ':"' + catQueryArray[1].trim() + '"';
      if(collectionQueryArray.length > 1) {
        const subCatQueryArray = collectionQueryArray[1].split(":");
        if(subCatQueryArray.length > 0) {
          collectioTitle = collectioTitle + ' AND ' + subCatQueryArray[0].trim() + ':"' + subCatQueryArray[1].trim() + '"';
        }
      }
    } else {
      collectioTitle = 'product_type:"' + collectioTitle+ '" OR ' + 'product_sub_type:"' + collectioTitle + '"';
    }
  }
}

collectioTitle = encodeURI(collectioTitle);
/*
  ?preview_prices=1 shows card prices for products the service still reports as
  available_online:false, so price/range presentation can be reviewed before the
  sell-on-web metafield is set. Display only — it does not enable purchasing,
  so those cards keep their "Contact a Flooring Expert" action.
*/
var RR_PREVIEW_PRICES = /[?&]preview_prices=1/.test(window.location.search);

var productPerPage = 24;
var totalResults;
var currentstart = 0;
var currentrows = productPerPage;
var sortOption = "price%20desc";
var selectedFields = new Map();
var baseProductUrl = serviceUrl + "/search?q=productEnabled:true AND "+collectioTitle+"&start="+currentstart +"&rows=" + currentrows + "&sort=price%20asc";
var filterProductUrl = serviceUrl + "/search?q="+collectioTitle+"&fq=meta-product-color:cape&start="+currentstart+"&rows="+currentrows;
var filteredResults;
function sortProducts(sort){
currentstart = 0;
sortOption = sort.value;
fetchSearchResults();
}
function getFilterProducts(productUrl){
  $.ajax({
      type: 'GET',
      url: productUrl,
      dataType: 'json',
      success: function(res){
          //filterProducts(res.response.docs, tag)
          filteredResults = res.response.docs;
          buildFilteredProducts(filteredResults);
          buildFacetForProducts(res.facet_counts.facet_fields, res.response.numFound);
          buildPagination(res.response.numFound, res.response.start);
       },
      error: function(status){
           console.log(status);
      }
  })
}

function filterProducts(products, tag) {
  var filteredProducts = products.filter(function(product){
      return product.tags.indexOf(tag) > -1;
  });

}

function buildPagination(totalProducts, start) {
      var $productPaginationContainer = $('#productPagination');
      $productPaginationContainer.empty();
      const maxPagesToShow = 5;
      var products = [],
      product = {}, 
      data = {}, 
      source = $("#productPaginationTemplate").html(),
      template = Handlebars.compile(source);
      var pagination = {};
      var totalpages = Math.ceil(totalProducts/productPerPage);
      var pages = [];
      if(totalProducts > 0) {
          var currentPage = (start/productPerPage) + 1;
          pagination.nextactive = currentPage > 0 && currentPage < totalpages;
          pagination.prevactive = currentPage > 1;
          pagination.nextPage = currentPage + 1;
          pagination.prevPage = currentPage -1;
          let pagesToShow = maxPagesToShow;
          let startIdex = 1;
          if(totalpages <= maxPagesToShow) {
            pagesToShow = totalpages;
          } else {
            if(currentPage >= maxPagesToShow) {
              startIdex = currentPage-2;
              pagesToShow = currentPage + maxPagesToShow -3;
            } else {
              startIdex = 1;
            }
            if(pagesToShow >= totalpages) {
              pagesToShow = totalpages;
              startIdex = currentPage-(maxPagesToShow - 1);
            }
          }
          for(var i=startIdex; i<=pagesToShow; i++) {
            var page = {};
            page.label = i;
            page.active = (i === currentPage);
            pages.push(page);
          }
      }
      pagination.pages = pages;
      pagination.lastpage = totalpages;
      pagination.firstpage = 1;
      
  data = {
    pagination: pagination
  } 

  $productPaginationContainer.append(template(data));
}

function fetchSearchResults(){
const filterQuery = formQuery();
getFilterProducts(filterQuery);
}

function fetchPage(pageNumber) {
  if(pageNumber !== 1) {
    console.log(location.search+"-"+pageNumber)
    history.pushState(null, "", "?pg=" + pageNumber);
  } else {
    location.search = '';
  }
  currentstart = (pageNumber - 1) * productPerPage;
  currentrow = productPerPage;
  fetchSearchResults();
  window.scroll({top: 0, left: 0, behavior: 'smooth' });
}

function buildFilteredProducts(filteredProds) {
  var $productContainer = $('#js-product-container');
      
      $productContainer.empty();
      var products = [],
      product = {}, 
      data = {}, 
      source = $("#ProductTemplate").html(),
      template = Handlebars.compile(source);
      products = filteredProds.map(function(productItem) {   
          return product = {
              id: productItem['productId'], 
              //description: productItem.body_html[0].replace(/<\/?[^>]+(>|$)/g, "").split(' ').join(' '), 
              title: productItem['title'],
              color: productItem['color'],
              //price: Shopify.formatMoney(productItem.price[0], {{ shop.money_format | json }})
              showPrice: (RR_PREVIEW_PRICES || productItem['available_online'][0]) && productItem['price'][0] !== 0,
              sellOnWeb: productItem['available_online'] && productItem['available_online'][0] && productItem['price'][0] !== 0 ? true : false,
              price: productItem['coveragePerBox'] && productItem['coveragePerBox'][0] !== 0 ? (productItem['price'][0]/productItem['coveragePerBox'][0]).toFixed(2) : productItem['price'][0].toFixed(2),
              coveragePerBox: productItem['coveragePerBox'] && productItem['coveragePerBox'][0] !== 0 ? true: false,
              // Area Rugs are sold each and carry one variant per size, so the
              // service's single `price` is only the cheapest size. Flagged here
              // and resolved to a real range by enhancePriceRanges() after render.
              showPriceRange: productItem['product_type'] === 'Area Rug',
              productCalloutTxt: (productItem['plpProductCallout'] && productItem['plpProductCallout'][0]!=='NA') ? productItem['plpProductCallout'][0] : "",
              showProductCallout: productItem['plpProductCallout'] && productItem['plpProductCallout'][0] !== 'NA',
              url: '/products/' + productItem['handle'],
              imgUrl: productItem['imageUrl'],
              roomImageUrl: productItem['roomImageUrl'] ?  productItem['roomImageUrl'][0] : "",
              handle: productItem['handle'],
              style: productItem['style'],
              isFav: checkIfFav(productItem['handle'])
          }
      });
      
  data = {
      product: products
  }

  $productContainer.append(template(data));
  enhanceSampleButtons();
  enhanceProductCards();
}

function convertToId(value) {
  return value.replace(/ |\/|\.|,/g, '-');
}

function mapFilterHeadings(filterLabel){
  if(filterLabel === "Install Method") {
    return "Installation Method";
  }
  if(filterLabel === "MadeInUSA") {
    return "Made In USA";
  }
  if(filterLabel === "Product Sub Type") {
    return "Type";
  }
  if(filterLabel === "Vendor") {
    return "Brand";
  }
  return filterLabel;
}

function buildFacetForProducts(facetFilters, totalResultCount) {
  var $productFacetContainer = $('#accordion');
      
      $productFacetContainer.empty();
      var facets = [],
      data = {}, 
      source = $("#ProductFacetTemplate").html(),
      template = Handlebars.compile(source);

      for (var key in facetFilters) {
        var rawfacetOptions = facetFilters[key];
        if (facetFilters.hasOwnProperty(key) && rawfacetOptions.length > 0) {
          var facet = {};
          facet.id = key;
          facet.label = mapFilterHeadings(humanize(key));
          var facetOptions = [];
          for(var i=0; i < rawfacetOptions.length; i=i+2) {
            var facetOption = {};
            facetOption.id = convertToId(rawfacetOptions[i]);
            facetOption.value = rawfacetOptions[i];
            facetOption.label = humanize(rawfacetOptions[i]);
            facetOption.count = rawfacetOptions[i+1];
            facetOptions.push(facetOption);
            /*if(facetOption.count != totalResultCount) {
              facetOptions.push(facetOption);
            }*/
          }
          facet.facetOptions = facetOptions;
          if(facetOptions.length > 0) {
            facets.push(facet);
          }
        }
      }

  data = {
      facets: facets
  } 

  $productFacetContainer.append(template(data));
  populateCheckedFields();
}

function populateCheckedFields() {
var selectedDataFilters = [];
if(selectedFields.size > 0) {
  selectedFields.forEach(function(value, key){
    var selectedDataFilter = {};
    selectedDataFilter.facetId = key;
    selectedDataFilter.id = value[0];
    selectedDataFilter.value = value[1];
    const filterOption = key;
    const filterValues = value;
    $('#' + filterOption).find("#" + filterValues[0]).attr('checked', true);
    selectedDataFilters.push(selectedDataFilter);
  });
}
  populateProductSelectedFacet(selectedDataFilters);
}

function populateProductSelectedFacet(selectedDataFilters) {
var $productSelectedFacetContainer = $('#selectedFilter');
      
      $productSelectedFacetContainer.empty();
      var facets = [],
      data = {}, 
      source = $("#ProductSelectedFacetTemplate").html(),
      template = Handlebars.compile(source);			  
  data = {
      selectedFacets: selectedDataFilters
  } 

  $productSelectedFacetContainer.append(template(data));
}

function reverseObject(obj) {
  var facetReversed = [];
  if(obj.size > 0) {
    obj.forEach(function(value, key){
      var selectedDataFilter = {};
      selectedDataFilter.facetId = key;
      selectedDataFilter.id = value[0];
      selectedDataFilter.value = value[1];
      const filterOption = key;
      const filterValues = value;
      $('#' + filterOption).find("#" + filterValues[0]).attr('checked', true);
      facetReversed.push(selectedDataFilter);
    });
  }
  return facetReversed.reverse();
};

function formQuery() {
var filterQuery = serviceUrl + "/search?q=productEnabled:true AND " + collectioTitle;
let i = 0;
let facetsSelected = false;
$('.facetOptions').each(function(){
  const facetFieldName = $(this).attr('id');
  if($(this).find('input:checkbox:checked').length > 0 ) {
    facetsSelected = true;
    filterQuery = filterQuery + ' AND ';
    i = i +1;
    var facetOptionArray = [];
    var facetValueLength = $(this).find('input:checkbox:checked').length;
    $(this).find('input:checkbox:checked').each(function(j){
        const facetValue = $(this).attr('value');
        const facetId = $(this).attr('id');
        if(j === 0) {
          filterQuery = filterQuery + facetFieldName + ':("' + facetValue + '"';
        } else {
          filterQuery = filterQuery + ' OR "' + facetValue + '"';
        }
        if(facetValueLength === j + 1) {
          filterQuery = filterQuery + ")";
        }
        facetOptionArray.push(facetId);
        facetOptionArray.push(facetValue);
    });
    selectedFields.set(facetFieldName, facetOptionArray);
  } else {
    selectedFields.delete(facetFieldName);
  }
});
filterQuery = filterQuery +"&start="+ currentstart+ "&rows=" + currentrows;
if(sortOption !== "") {
  filterQuery = filterQuery + "&sort=" + sortOption;
}
return filterQuery;
}

function filterResults(){
currentrows = productPerPage;
currentstart = 0;
if($('input:checkbox:checked').length === 0) {
  selectedFields.clear();
  getFilterProducts(baseProductUrl);
} else {
  fetchSearchResults();
}
}

function removeFilter(filterId, facetId) {
$('#' + facetId).find("#" + filterId).attr('checked', false);
filterResults();
}

function toggleFav(productData) {
  if(productData.isFav) {
    removeFav(productData);
  } else {
    addFav(productData);
  }
  buildFilteredProducts(filteredResults);
  checkAnUpdateFavStar();
}

function checkAndGoToSpecificPage(browserBack) {
  var pageNum = '';
  if(location.search.indexOf('pg') !== -1) {
    let urlParams = new URLSearchParams(window.location.search);
    pageNum = urlParams.get('pg');
    // pageNum = location.hash.replace("#pg=", '');
  }
  if(browserBack && pageNum === '') {
    pageNum = 1;
  }
  if(pageNum !== '') {
    fetchPage(pageNum);
  }
}

/* =========================================================
   Free-sample buttons on collection cards (Phase 2 wiring)
   The search index has no sample flag, so we detect a sample by probing
   /products/{handle}-sample.js — a 200 means a sample exists and gives us
   the sample variant id; a 404 means no sample. Results are cached in
   sessionStorage so pagination/filtering doesn't refetch. Clicking adds the
   sample via a /cart/add form POST, mirroring the product page sample form.
   ========================================================= */
var RR_SAMPLE_CACHE = {};
try { RR_SAMPLE_CACHE = JSON.parse(sessionStorage.getItem('rrSampleCache') || '{}'); } catch (e) { RR_SAMPLE_CACHE = {}; }

function rrPersistSampleCache() {
  try { sessionStorage.setItem('rrSampleCache', JSON.stringify(RR_SAMPLE_CACHE)); } catch (e) {}
}

function rrApplySampleResult($btn, variantId) {
  if (variantId) {
    $btn.attr('data-sample-id', variantId).removeAttr('hidden');
  } else {
    $btn.remove();
  }
}

function rrCheckSampleForButton(btn) {
  var $btn = $(btn);
  if ($btn.data('sampleChecked')) return;
  $btn.data('sampleChecked', true);
  var handle = $btn.attr('data-handle');
  if (!handle) { $btn.remove(); return; }

  var cached = RR_SAMPLE_CACHE[handle];
  if (cached !== undefined) { rrApplySampleResult($btn, cached); return; }

  fetch('/products/' + handle + '-sample.js', { headers: { 'Accept': 'application/json' } })
    .then(function (res) { return res.ok ? res.json() : null; })
    .then(function (p) {
      var vid = false;
      if (p && p.variants && p.variants.length) {
        var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
        vid = (v && v.id) || false;
      }
      RR_SAMPLE_CACHE[handle] = vid;
      rrPersistSampleCache();
      rrApplySampleResult($btn, vid);
    })
    .catch(function () { RR_SAMPLE_CACHE[handle] = false; $btn.remove(); });
}

/*
  Storefront enrichment for multi-variant products (Area Rugs: one variant per size).

  The search service indexes a single `price` per product and no variant count,
  so a rug card would advertise $549 for a rug that runs to $3,549, and the
  quick-buy overlay would silently add the cheapest size. Both need the real
  product, so it is fetched once per handle and cached for the session — the same
  fetch-after-render pattern as the Free Sample buttons below.

  Two things are applied when it resolves:
    - the price becomes a range ($549 – $3,549)
    - the Add to Cart button becomes "Choose a Size" and links to the PDP
      instead of opening quick-buy, because size is the purchase decision for a
      rug and the overlay has no size selector.

  When the service starts indexing price_min/price_max/variant_count this can
  read them directly and the fetch can go away.
*/
var RR_PRODUCT_CACHE = {};
try { RR_PRODUCT_CACHE = JSON.parse(sessionStorage.getItem('rrProductCache') || '{}'); } catch (e) { RR_PRODUCT_CACHE = {}; }

function rrPersistProductCache() {
  try { sessionStorage.setItem('rrProductCache', JSON.stringify(RR_PRODUCT_CACHE)); } catch (e) {}
}

// 54900 -> "549", 354900 -> "3,549", 299 -> "2.99". Cards stay compact by
// dropping ".00" on whole-dollar amounts.
function rrFormatCents(cents) {
  var amount = Number(cents) / 100;
  var decimals = amount % 1 === 0 ? 0 : 2;
  return amount.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/* Fetch (or replay from cache) the variant facts we need for one handle. */
function rrFetchProductInfo(handle) {
  var cached = RR_PRODUCT_CACHE[handle];
  if (cached !== undefined) { return Promise.resolve(cached); }
  return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
    .then(function (res) { return res.ok ? res.json() : null; })
    .then(function (p) {
      var info = p ? {
        variants: (p.variants || []).length,
        varies: !!p.price_varies,
        min: p.price_min,
        max: p.price_max
      } : null;
      RR_PRODUCT_CACHE[handle] = info;
      rrPersistProductCache();
      return info;
    })
    .catch(function () {
      RR_PRODUCT_CACHE[handle] = null;
      return null;
    });
}

function rrApplyProductInfo(handle, info) {
  if (!info) return;

  if (info.varies && info.max && info.max !== info.min) {
    $('[data-pc-price-range="' + handle + '"]').each(function () {
      var $el = $(this);
      var unit = $el.find('.denomination').first();
      var unitHtml = unit.length ? unit.prop('outerHTML') : '';
      $el.html('$' + rrFormatCents(info.min) + ' &ndash; $' + rrFormatCents(info.max) + unitHtml);
    });
  }

  /*
    More than one variant means the shopper has to choose a size, which the
    quick-buy overlay cannot offer — send them to the product page instead of
    adding the cheapest size behind their back.
  */
  if (info.variants > 1) {
    $('[data-pc-variant-check="' + handle + '"]')
      .attr('data-multi-variant', '1')
      .attr('data-action', 'choose-size')
      .text('Choose a Size');
  }
}

function enhanceProductCards() {
  var handles = {};
  $('[data-pc-price-range], [data-pc-variant-check]').each(function () {
    var $el = $(this);
    var handle = $el.attr('data-pc-price-range') || $el.attr('data-pc-variant-check');
    if (handle) handles[handle] = true;
  });
  Object.keys(handles).forEach(function (handle) {
    rrFetchProductInfo(handle).then(function (info) { rrApplyProductInfo(handle, info); });
  });
}

function enhanceSampleButtons() {
  $('.pc-sample').each(function () { rrCheckSampleForButton(this); });
}

function rrUpdateCartCount() {
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      $('.cart .badge').text(cart.item_count);
    })
    .catch(function () {});
}

/* Add the sample via the AJAX cart API so the shopper stays on the listing. */
function rrAddSampleToCart(variantId, $btn) {
  var original = $btn ? $btn.html() : null;
  if ($btn) { $btn.prop('disabled', true).addClass('is-loading'); }
  // rrCartDrawerAdd (global.js) adds via AJAX and opens the cart flyout drawer
  var add = window.rrCartDrawerAdd
    ? window.rrCartDrawerAdd(variantId, 1)
    : fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
  add
    .then(function () {
      rrUpdateCartCount();
      if ($btn) {
        $btn.removeClass('is-loading').addClass('is-added').html('<i class="fas fa-check"></i> Added');
        setTimeout(function () {
          $btn.removeClass('is-added').prop('disabled', false).html(original);
        }, 2200);
      }
    })
    .catch(function () {
      if ($btn) { $btn.removeClass('is-loading').prop('disabled', false).html(original); }
      window.rrNotify("Sorry, we couldn't add that sample. Please try again.");
    });
}

$(document).on('click', '.pc-sample', function (e) {
  e.preventDefault();
  var id = $(this).attr('data-sample-id');
  if (!id) { return; }
  var $btn = $(this);
  // enforce the 3-samples-per-order limit before adding
  if (typeof window.rrCheckSampleLimit === 'function') {
    window.rrCheckSampleLimit(function (allowed) {
      if (allowed) { rrAddSampleToCart(id, $btn); }
      else { window.rrNotify(window.rrSampleLimitMessage || 'There is a limit of 3 sample per order, you reached max 3 sample for this cart', window.rrSampleLimitTitle || 'Sample Limit'); }
    });
  } else {
    rrAddSampleToCart(id, $btn);
  }
});

/* =========================================================
   "Buy by the box" quick-buy overlay
   Storefront pages send X-Frame-Options: DENY, so they can't be iframed.
   Instead we fetch the trimmed product page (?view=quickbuy, rendered with no
   layout so it's a bare fragment) and inject it into the modal. The fragment
   drops the image gallery, alternate colors, product details and specs — just
   the buy panel. Its add-to-cart / sample forms POST to /cart/add normally
   (they're part of this page now), navigating to /cart.
   ========================================================= */
function rrOpenQuickBuy(url) {
  if (!url) return;
  var $modal = $('#pc-quickbuy');
  if (!$modal.length) { window.location.href = url; return; }
  var sep = url.indexOf('?') > -1 ? '&' : '?';
  var $content = $modal.find('.pc-modal__content');
  $content.empty();
  $modal.find('.pc-modal__loader').show();
  $modal.addClass('is-open').attr('aria-hidden', 'false');
  $('body').addClass('pc-modal-open');
  fetch(url + sep + 'view=quickbuy', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function (r) { return r.text(); })
    .then(function (html) {
      $modal.find('.pc-modal__loader').hide();
      $content.html(html);
      var $car = $content.find('.quickbuy-carousel');
      if ($car.length && $.fn.owlCarousel) {
        $car.owlCarousel({
          items: 1, loop: false, nav: true, dots: false, margin: 10, autoHeight: true,
          navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>']
        });
        // Owl measures before the remote images finish loading, so the first
        // slide can render blank until a nav click. Refresh once things settle
        // and again as each image loads.
        var refresh = function () { $car.trigger('refresh.owl.carousel'); };
        setTimeout(refresh, 60);
        $car.find('img').each(function () {
          if (this.complete) { refresh(); }
          else { $(this).on('load', refresh); }
        });
      }
    })
    .catch(function () {
      $modal.find('.pc-modal__loader').hide();
      $content.html('<div class="pc-modal__error">Sorry, this product could not be loaded. <a href="' + url + '">Open the product page</a>.</div>');
    });
}

function rrCloseQuickBuy() {
  var $modal = $('#pc-quickbuy');
  if (!$modal.length) return;
  $modal.removeClass('is-open').attr('aria-hidden', 'true');
  $modal.find('.pc-modal__content').empty();
  $('body').removeClass('pc-modal-open');
}

/* box calculator inside the injected quick-buy panel (mirrors product.liquid) */
function rrQbCompute() {
  var $m = $('#pc-quickbuy');
  var coverage = Number($m.find('.quickbuy').attr('data-coverage'));
  var l = $m.find('#length').val(), w = $m.find('#width').val();
  if (l !== '' && w !== '') {
    var sqft = l * w;
    if ($m.find('#check1').is(':checked')) { sqft = sqft + ((sqft * 10) / 100); }
    $m.find('#sqft').val(sqft);
    if (coverage) {
      var boxes = Math.ceil(sqft / coverage);
      $m.find('#input').val(boxes);
      $m.find('#Quantity').val(Number(boxes));
    }
  }
}

$(document).on('click', '.pc-buybox', function (e) {
  var $btn = $(this);
  var url = $btn.attr('data-url') || $btn.attr('href');

  // Known multi-variant: let the anchor navigate to the product page.
  if ($btn.attr('data-multi-variant') === '1') { return; }

  // Range candidate whose variant count has not come back yet — resolve before
  // deciding, so a fast click can never add the wrong size via quick-buy.
  var handle = $btn.attr('data-pc-variant-check');
  if (handle && RR_PRODUCT_CACHE[handle] === undefined) {
    e.preventDefault();
    rrFetchProductInfo(handle).then(function (info) {
      rrApplyProductInfo(handle, info);
      if (info && info.variants > 1) { window.location.href = url; }
      else { rrOpenQuickBuy(url); }
    });
    return;
  }

  e.preventDefault();
  rrOpenQuickBuy(url);
});
$(document).on('click', '[data-pc-close]', function () { rrCloseQuickBuy(); });
$(document).on('keydown', function (e) { if (e.key === 'Escape') rrCloseQuickBuy(); });

/* delegated handlers scoped to the modal (work for injected content) */
$(document).on('keyup', '#pc-quickbuy #length, #pc-quickbuy #width', rrQbCompute);
$(document).on('click', '#pc-quickbuy #check1', rrQbCompute);
$(document).on('change', '#pc-quickbuy #input', function () { $('#pc-quickbuy #Quantity').val(Number($(this).val())); });
$(document).on('click', '#pc-quickbuy #minus', function (e) {
  e.preventDefault();
  var $i = $('#pc-quickbuy #input'); var v = Number($i.val()); v = v > 1 ? v - 1 : 1;
  $i.val(v); $('#pc-quickbuy #Quantity').val(v);
});
$(document).on('click', '#pc-quickbuy #plus', function (e) {
  e.preventDefault();
  var $i = $('#pc-quickbuy #input'); var v = Number($i.val()); v = v >= 1 ? v + 1 : 1;
  $i.val(v); $('#pc-quickbuy #Quantity').val(v);
});
$(document).on('show.bs.collapse', '#pc-quickbuy .collapse', function () {
  $(this).parent().find('.fa').removeClass('fa-plus').addClass('fa-minus');
});
$(document).on('hide.bs.collapse', '#pc-quickbuy .collapse', function () {
  $(this).parent().find('.fa').removeClass('fa-minus').addClass('fa-plus');
});

$(document).ready(function(){

  //var baseProductUrl = "{{ 'products.json' | asset_url }}";
  //var filterProductUrl = "{{ 'product-filtered.json' | asset_url }}";
  getFilterProducts(baseProductUrl);
  checkAndGoToSpecificPage(false);

  $(window).on('popstate', function() {
    checkAndGoToSpecificPage(true);
  });

});